import styled from "styled-components";
import {Button} from "@material-ui/core";

import {SectionTabs} from "components/SectionTabs";

export const Container = styled.div`
  padding: 1.5rem;
  background-color: #fff;
  height: calc(100% - 78px);
  overflow-y: auto;
  max-width: 900px;
  margin: 0 auto;
  
  @media(min-width: 768px) {
    padding: 2rem;
  }
`

export const StyledSectionTabs = styled(SectionTabs)`
  margin: 1.5rem 0;
  
  @media(min-width: 768px) {
    margin: 2rem 0;
  }
`

export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  line-height: 1.5;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopupButton = styled(Button)`
  width: 48% !important;
`
